import styled from 'styled-components'
import { COLORS } from '../../constants'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 92%;
`

export const Wrapper = styled.div`
  background-color: ${COLORS.primary};
  width: 100%;
  height: 100%;
  padding-bottom: 2rem;
  overflow: hidden;
`

export const MiddleBorder = styled.div`
  width: 2rem;
  height: 100%;
  background-color: ${COLORS.primary};
`
